module.exports = "<p>\r\n  help-navbar works!\r\n</p>\r\n"